const colors = {
  primary: '#fff',
  secondary: '#222',
  accent: '#1c86f2',
  subtle: 'rgba(0, 0, 0, 0.5)',
}

export default colors



// WEBPACK FOOTER //
// ./src/utils/colors.js